import React, { useCallback, useMemo } from "react";
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  Button,
  ModalHeader,
  ModalOverlay,
  Box,
} from "@chakra-ui/react";
import { Col, Row } from "react-bootstrap";
import dateTimeFormat from "jsFunctions/dateTimeFormat";
import {  useSelector } from "react-redux";
import GstAmountTable from "./dataChangeTable/gstAmountTable";
import RefundAmountTable from "./dataChangeTable/refundAmountTable";
import TdsAmountTable from "./dataChangeTable/tdsTable";
import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";
import { currencySymbolByCode } from "components/allForm/SalesItem/currencyJson";
import PaymentRecordTable from "./dataChangeTable/paymentRecordTable";

const InvoiceDataChangeModal = ({
  openModal,
  closeModal,
  editData,
  currentData,
  isConfirmed,
  role,
  moduleTyp
}) => {
  const clientList = useSelector((state) => state.clientData);
  
  const getcurrectData = Object.fromEntries(
    Array.from(currentData?.entries() || []).map(([key, value]) => [
      key,
      key === "pmtRecords" ? JSON.parse(value) : value,
    ])
  );

 
  const currentSpentInfo = useMemo(() => {
    if (getcurrectData?.pmtRecords) {
      return getcurrectData.pmtRecords.map(item => item);
    }
    return [];
  }, [getcurrectData]);

  const editSpentInfo = useMemo(() => {
    if (editData?.pmtRc) {
      const currSpentData = getcurrectData?.pmtRecords || [];
      const spentData = editData.pmtRc || [];
      const dummObjectCount = currSpentData.length - spentData.length;

      return [
        ...spentData,
        ...Array(Math.max(0, dummObjectCount)).fill({}),
      ];
    }
    return [];
  }, [getcurrectData, editData]);

  const currentRefundInfo = useMemo(() => {
    if (getcurrectData?.refundInfo) {
      const refundData = JSON.parse(getcurrectData.refundInfo) || [];
      return refundData.map(item => item);
    }
    return [];
  }, [getcurrectData]);

  const editRefundInfo = useMemo(() => {
    if (editData?.rfdInfo?.list) {
      const refundData = editData.rfdInfo.list || [];
      const currrefundData = JSON.parse(getcurrectData?.refundInfo || '[]') || [];
      const dummObjectCount = currrefundData.length - refundData.length;

      return [
        ...refundData,
        ...Array(Math.max(0, dummObjectCount)).fill({}),
      ];
    }
    return [];
  }, [getcurrectData, editData]);


    const currentGstInfo = useMemo(() => {
      if (getcurrectData?.gstRecords?.length) {
        const gstData = JSON.parse(getcurrectData.gstRecords) || [];
        return gstData.map((item) => {
          if (item?.bsAmt) {
            return item;
          }
          return null; 
        }).filter(Boolean); 
      }
      return [];
    }, [getcurrectData]);

    const editGstInfo = useMemo(() => {
      if (editData?.gstRc?.length) {
        const gstData = editData.gstRc || [];
        const currgstData = getcurrectData?.gstRecords ? JSON.parse(getcurrectData.gstRecords) : [];
        const dummObjectCount = currgstData.length - gstData.length;
  
        return [
          ...gstData
            .filter(item => item?.bsAmt),
          ...Array(dummObjectCount).fill({
            bsAmt: "",
            cId: null,
            gstNo: "",
            amt: {
              c: "",
              s: "",
              i: ""
            },
          })
        ];
      }
      return [];
    }, [editData, getcurrectData]);

    const currentTdsInfo = useMemo(() => {
      if (getcurrectData?.tdsRecords) {
        const tdsData = JSON.parse(getcurrectData.tdsRecords) || [];
        return tdsData;
      }
      else{

        return []
      }
    }, [getcurrectData]);

    const editTdsInfo = useMemo(() => {
      if (editData?.tdsApl?.tdsRc) {
        const tdsData = editData?.tdsApl?.tdsRc || [];
        const currtdsData = getcurrectData?.tdsRecords ? JSON.parse(getcurrectData.tdsRecords) : [];
        const dummObjectCount = currtdsData.length - tdsData.length;
  
        return [
          ...tdsData
            .filter(item => item?.bsAmt),
          ...Array(dummObjectCount).fill({
            bsAmt: "", 
            prc: 0,
            tdsAmt:0,
          })
        ];
      }
      return [];
    }, [editData, getcurrectData]);

  
  const fetchClientName = useCallback((clientId) => 
    clientList.find(client => client._id === clientId)?.clName || "", 
    [clientList]
  );

  const fetchProjectName = useCallback((clientId, projectId) => {
    const client = clientList.find((client) => client._id === clientId);
    return client?.prjs?.find((project) => project._id === projectId)?.prj || '';
  }, [clientList]);
  
  console.log(editData)
  return (
    <>
      <Modal
        isOpen={openModal}
        onClose={closeModal}
        size="xl"
        className="modal-main data-change-model"
        scrollBehavior={"inside"}
        
      >
        <ModalOverlay />
        <ModalContent 
         top="0" // Position it at the top
          margin="0 auto" // Center it horizontally
          bottom="0"
        className="data-change-content info-model"
>
          <ModalHeader className="expense-modal-header data-change-modal-header">
            <>
              {/* Compare fields */}
              <Row className="modal-header-row">
                <Col>
                  <h6>
                    Current
                  </h6>
                </Col>
                
                <Col>
                  <h6 >
                    Edited
                  </h6>
                </Col>
              </Row>
            </>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody className="mt-0">
            <Row>
              <Col className="row-col">
                <div className="row-table">
                  <Row className="rowC">
                        <h4 className="row-heading">
                          Invoice Details :
                        </h4>
                      </Row>
                 
                  <Row className="rowC">
                    <Col>invoice Date : {editData?.inDt ? dateTimeFormat(editData?.inDt):""}</Col>
                  </Row>
                  <Row className="rowC">
                    <Col>Proforma Date : {editData?.pfiDt ? dateTimeFormat(editData?.pfiDt) : ""}</Col>
                  </Row>
                  <Row className="rowC">
                    <Col>Invoice Currency : {editData?.inCr}</Col>
                  </Row>

                  <Row className="rowC">
                        <Col className={`${editData.invSub !== getcurrectData.invoiceSubject  ? 'data_compare_red' : '' }`}>SubJect Of Invoice : {editData.invSub}</Col>
                      </Row>
                 
                      
                      <Row className="rowC">
                        <h4
                          className="row-heading"
                        >
                          Invoice Type :
                        </h4>
                      </Row>
                      
                      <Row className="rowC">
                        <Col className={`${editData?.mjId?._id !== getcurrectData.majorId  ? 'data_compare_red' : '' }`}>Major Type : {editData.mjId?.val}</Col>
                      </Row>
                      <Row className="rowC">
                        <Col className={`${editData?.mnId?._id !== getcurrectData.minorId  ? 'data_compare_red' : '' }`}>Minor Type : {editData?.mnId?.val}</Col>
                      </Row>
                      <Row className="rowC">
                        <Col className={`${editData?.msId?._id !== getcurrectData.minorSubCategoryId  ? 'data_compare_red' : '' }`}>Minor Sub Category : {editData?.msId?.val}</Col>
                      </Row>
                     
                     
                      <Row className="rowC">
                        <Col className={`${editData?.clId?._id !== getcurrectData.clientName  ? 'data_compare_red' : '' }`}>Client Name : {fetchClientName(editData.clId?._id)}</Col>
                      </Row>
                      <Row className="rowC">
                        <Col className={`${editData.prId?._id !== getcurrectData.projectName  ? 'data_compare_red' : '' }`}>Project Name : {fetchProjectName(editData.clId?._id,editData.prId?._id)}</Col>
                      </Row>
                     
                      <Row className="rowC">
                        <Col className={`${editData.rmks !== getcurrectData.remarks  ? 'data_compare_red' : '' }`}>Remarks : {editData.rmks}</Col>
                      </Row>

                      

                      <Row className="rowC">
                        <h4
                          className="row-heading"
                        >
                          Payment Information : 
                        </h4>
                      </Row>
                      <Row className="rowC">
                        <Col className={`${Number(editData?.pyInfo?.apAmt || 0) !== Number(getcurrectData?.requestedAmount || 0)  ? 'data_compare_red' : '' }`}>
                            <Box display="flex">
                            Requested Amount : {currencySymbolByCode(editData?.inCr|| "INR")} {formatAmountIndianRupees(editData?.pyInfo?.apAmt)}
                            </Box>
                        </Col>
                      </Row>

                     <PaymentRecordTable editSpentInfo={editSpentInfo} currentSpentInfo={currentSpentInfo} type="current" currency={editData?.inCr} />
                 
                  {(role === "Manager" || role === "Admin") &&
                 
                  <>
                    <Row className="rowC">
                          <h4
                            className="row-heading"
                          >
                            TDS Deducted :
                          </h4>
                        </Row>
                        <TdsAmountTable editTdsData={editTdsInfo} currentTdsData={currentTdsInfo} type="current" />

                 
                  
                  <Row className="rowC">
                        <h4
                          className="row-heading"
                        >
                          GST Information : 
                        </h4>
                      </Row>
                      <GstAmountTable editGstInfo={editGstInfo} currentGstInfo={currentGstInfo} type="current"/>

                     

                      <Row className="rowC">
                        <h4
                          className="row-heading" 
                        >
                          Refund Information : 
                        </h4>
                      </Row>
                      <RefundAmountTable editRefundInfo={editRefundInfo} currentRefundInfo={currentRefundInfo} type="current"/>

                    </>
                  }
                </div>
              </Col>
              <Col className="row-col">
                <div className="row-table">
                <Row className="rowC">
                        <h4
                         className="row-heading"
                        >
                          Invoice Details :
                        </h4>
                      </Row>
                 
                  <Row className="rowC">
                    <Col>
                      invoice Date : {getcurrectData.invoiceDate ? dateTimeFormat(getcurrectData.invoiceDate) : ""}
                    </Col>
                  </Row>
                  
                  <Row className="rowC">
                    <Col>Proforma Date : {getcurrectData.proformaDate ?  dateTimeFormat(getcurrectData?.proformaDate) : ""}</Col>
                  </Row>
                  <Row className="rowC">
                    <Col>Invoice Currency : {getcurrectData?.currency}</Col>
                  </Row>
                  <Row className="rowC">
                        <Col className={`${editData.invSub !== getcurrectData.invoiceSubject  ? 'data_compare_red' : '' }`}>SubJect Of Invoice : {getcurrectData.invoiceSubject}</Col>
                      </Row>
                    <>
                     
                      <Row className="rowC">
                        <h4
                          className="row-heading"
                        >
                          Invoice Type :
                        </h4>
                      </Row>
                      

                     
                      
                      <Row className="rowC">
                        <Col className={`${editData?.mjId?._id !== getcurrectData?.majorId  ? 'data_compare_green' : '' }`}>Major Type : {getcurrectData.expenseType}</Col>
                      </Row>
                      <Row className="rowC">
                        <Col className={`${editData?.mnId?._id !== getcurrectData.minorId  ? 'data_compare_green' : '' }`}>Minor Type : {getcurrectData.minorType}</Col>
                      </Row>
                      <Row className="rowC">
                        <Col className={`${editData?.msId?._id !== getcurrectData.minorSubCategoryId  ? 'data_compare_green' : '' }`}>Minor Sub Category : {getcurrectData.minorTypeCategory ? getcurrectData.minorTypeCategory : ''}</Col>
                      </Row>
                     
                      <Row className="rowC">
                        <Col className={`${editData?.clId?._id !== getcurrectData.clientName  ? 'data_compare_green' : '' }`}>Client Name : {fetchClientName(getcurrectData.clientName)}</Col>
                      </Row>
                      <Row className="rowC">
                        <Col className={`${editData?.prId?._id !== getcurrectData.projectName  ? 'data_compare_green' : '' }`}>Project Name : {fetchProjectName(getcurrectData.clientName,getcurrectData.projectName)}</Col>
                      </Row>
                      <Row className="rowC">
                        <Col className={`${editData.rmks !== getcurrectData.remarks  ? 'data_compare_red' : '' }`}>Remarks : {getcurrectData.remarks}</Col>
                      </Row>
                     

                      <Row className="rowC">
                        <h4
                          className="row-heading"
                        >
                          Payment Information :
                        </h4>
                      </Row>
                      <Row className="rowC">
                        <Col className={`${Number(editData?.pyInfo?.apAmt || 0) !== Number(getcurrectData?.requestedAmount || 0)  ? 'data_compare_green' : '' }`}>
                        <Box display="flex">

                        Requested Amount : {currencySymbolByCode(getcurrectData?.currency|| "INR")} {formatAmountIndianRupees(parseFloat(getcurrectData?.requestedAmount))}
                        </Box>
                        </Col>
                      </Row>
                       
                    </>
                    <PaymentRecordTable editSpentInfo={editSpentInfo} currentSpentInfo={currentSpentInfo} type="edited" currency={getcurrectData?.currency} />
                 
                    {(role === "Manager" || role === "Admin") &&
                    <>
                  <Row className="rowC">
                        <h4
                          className="row-heading"
                        >
                          TDS Deducted :
                        </h4>
                      </Row>
                      <TdsAmountTable editTdsData={editTdsInfo} currentTdsData={currentTdsInfo} type="edited" />

                 
                  
               
                  <Row className="rowC">
                        <h4
                          className="row-heading"
                        >
                          GST Information : 
                        </h4>
                      </Row>
                      <GstAmountTable editGstInfo={editGstInfo} currentGstInfo={currentGstInfo} type="edited"/>


                 
                      <Row className="rowC">
                        <h4
                          className="row-heading" 
                        >
                          Refund Information : 
                        </h4>
                      </Row>
                      <RefundAmountTable editRefundInfo={editRefundInfo} currentRefundInfo={currentRefundInfo} type="edited"/>
                  
                      
                    </>
                    }
                   
                 
                </div>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter className="border-2 p-0 pt-4 pb-2">
            <Button
              type="submit"
              className="submit-btn"
              variant="brand"
              style={{ background: "#191063", minWidth: "100px" }}
              onClick={() => {
                isConfirmed();
                closeModal();
              }}
            >
              ok
            </Button>
            <Button
              type="submit"
              className="submit-btn"
              variant="brand"
              style={{ background: "#191063", minWidth: "100px" }}
              onClick={() => {
                closeModal();
              }}
            >
              cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default InvoiceDataChangeModal;
